export default __webpack_public_path__ + "static/media/eye_on.f0bc7a1c.svg";